export const useCategoryItems = (
  sellingItemCategories: any[],
  activeCategory: number,
  categoryActiveItems: (category: any) => any[],
  rentalServices?: any[],
  hasRentalCategory = true
) => {
  if (sellingItemCategories && sellingItemCategories.length > 0) {
    const currentCategory = sellingItemCategories[activeCategory];
    
    if (currentCategory?.name === "Events" && currentCategory.events) {
      const events = [...currentCategory.events].sort((a: any, b: any) => {
        const timeA = new Date(a.startTime).getTime();
        const timeB = new Date(b.startTime).getTime();
        return timeA - timeB;
      });
      
      return {
        filteredSellingItems: [], // Events don't use filteredSellingItems
        events,
        rentalServices: [],
        isRentalCategory: false,
      };
    }
  }
  
  // Check if current category is Rental (when activeCategory is beyond existing categories)
  const isRentalCategory = sellingItemCategories && 
    hasRentalCategory &&
    activeCategory === sellingItemCategories.length;
  
  if (isRentalCategory && rentalServices) {
    return {
      filteredSellingItems: [],
      events: [],
      rentalServices,
      isRentalCategory: true,
    };
  }
  
  const filteredSellingItems = sellingItemCategories && activeCategory < sellingItemCategories.length
    ? categoryActiveItems(sellingItemCategories[activeCategory])
    : [];

  return {
    filteredSellingItems,
    events: [], // Non-events categories don't have events
    rentalServices: [],
    isRentalCategory: false,
  };
};
